import "core-js/modules/es.array.includes.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/aosen-logo.png';
const _hoisted_1 = {
  class: "app-wrapper"
};
const _hoisted_2 = {
  class: "app-header"
};
const _hoisted_3 = {
  class: "app-tabs"
};
import { computed } from 'vue';
import { useRoute } from 'vue-router';
export default {
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const activeTab = computed(() => {
      if (route.path === '/newsDetail') return '/news';else if (route.path?.includes('scenic/')) return '/scenic';else if (route.path?.includes('lowcarbon/detail')) return '/lowcarbon';else return route.path;
    });
    return (_ctx, _cache) => {
      const _component_van_tab = _resolveComponent("van-tab");
      const _component_van_tabs = _resolveComponent("van-tabs");
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("img", {
        src: _imports_0
      }, null, -1)), _createElementVNode("div", _hoisted_3, [_createVNode(_component_van_tabs, {
        active: activeTab.value,
        "onUpdate:active": _cache[0] || (_cache[0] = $event => activeTab.value = $event),
        route: "",
        color: "#2bb061",
        "title-active-color": "#2bb061",
        "line-width": "80px"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_tab, {
          name: "/",
          to: "/",
          title: "首页"
        }), _createVNode(_component_van_tab, {
          name: "/news",
          to: "/news",
          title: "新闻动态"
        }), _createVNode(_component_van_tab, {
          name: "/parkService",
          to: "/parkService",
          title: "游园服务"
        }), _createVNode(_component_van_tab, {
          name: "/scenic",
          to: "/scenic",
          title: "著名景点"
        }), _createVNode(_component_van_tab, {
          name: "/lowcarbon",
          to: "/lowcarbon",
          title: "低碳园林"
        }), _createVNode(_component_van_tab, {
          name: "/about",
          to: "/about",
          title: "联系我们"
        })]),
        _: 1
      }, 8, ["active"])])]), _createVNode(_component_router_view)]);
    };
  }
};